export enum AlertType {
  Success='Success',
  Error='Error',
  Info='Info',
  Warning='Warning'
}
